import SuperFetch from '../../../superFetch.js';

class RecommendStoreApi {
  /**
   *  [추천 브랜드 리스트] 추천 브랜드 리스트 요청하기
   */
  getRecommendStoreList = (data) => SuperFetch.post('/recommend/store/list', data);

  /**
   *  [추천 브랜드 상세] 추천 브랜드 상세 요청하기
   */
  getRecommendStoreDetail = (data) => SuperFetch.post('/recommend/store/detail', data);

  /**
   *  추천 브랜드 복사하기 전 필요한 데이터 가져오기
   */
  prepareCopyRecommendStore = (data) => SuperFetch.post('/recommend/store/insert/preparation/copy', data);

  /**
   *  추천 브랜드 등록하기 전 필요한 데이터 가져오기
   */
  prepareCreateRecommendStore = (data) => SuperFetch.post('/recommend/store/insert/preparation/insert', data);

  /**
   *  [추천 브랜드 복사] 추천 브랜드에 연결할 아이템 리스트 요청하기
   */
  getRecommendStoreItemList = (data) => SuperFetch.post('/recommend/store/insert/preparation/list', data);

  /**
   *  [추천 브랜드 복사] 추천 브랜드 등록/복사하기
   */
  createRecommendStore = (data) => SuperFetch.post('/recommend/store/insert', data);

  /**
   *  [추천 브랜드 복사] 전체 브랜드 리스트 EXCEL 다운로드
   */
  getRecommendStoreItemListExcelDownload = (data) =>
    SuperFetch.post('/recommend/store/insert/preparation/list/excel/download', data);

  /**
   *  [추천 브랜드 복사] 선택된 브랜드 리스트 EXCEL 다운로드
   */
  getSelectedRecommendStoreItemListExcelDownload = (data) =>
    SuperFetch.post('/recommend/store/insert/preparation/list/excel/download/selected', data);

  /**
   *  [추천 브랜드 복사] 브랜드 리스트 EXCEL 업로드
   */
  setRecommendStoreItemListExcelUpload = (data) =>
    SuperFetch.post('/recommend/store/insert/preparation/list/excel/upload', data);
}

export default new RecommendStoreApi();
